/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import TagsidTag from './TagsidTag';

/**
 * The TagsIdBody model module.
 * @module model/TagsIdBody
 * @version v0.3
 */
export default class TagsIdBody {
  /**
   * Constructs a new <code>TagsIdBody</code>.
   * @alias module:model/TagsIdBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>TagsIdBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TagsIdBody} obj Optional instance to populate.
   * @return {module:model/TagsIdBody} The populated <code>TagsIdBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TagsIdBody();
      if (data.hasOwnProperty('tag'))
        obj.tag = TagsidTag.constructFromObject(data['tag']);
    }
    return obj;
  }
}

/**
 * @member {module:model/TagsidTag} tag
 */
TagsIdBody.prototype.tag = undefined;

